import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomeLayout from './Components/HomeLayout'; // This is the new layout component
import PredictionPage from './Components/PredictionPage'; // Prediction page
import AboutPage from './Components/AboutPage';
import ContactUs from "./Components/ContactUs";
import HowToUsePage from './Components/HowtoUsePage';
import UmamiDbPage from './Components/UmamiDbPage';
import Header from './Components/Header';
import UmamiDBPredictorPage from './Components/UmamiDBPredictorPage';
import SearchPage from './Components/SearchPage';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<HomeLayout />} />
        <Route path="/predict" element={<PredictionPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/how-to-use" element={<HowToUsePage />} />
        <Route path="/umami-db" element={<UmamiDbPage />} />
        <Route path="/umami-predictor" element={<UmamiDBPredictorPage />} />
        <Route path="/search" element={<SearchPage />} />
        {/* Add other routes here as needed */}
      </Routes>
    </Router>
  );
}

export default App;
